export const global = {
  gutter: "30px",
  addons: {
    padding: ["50px 0", "100px 0"],
    background:
      "linear-gradient(to top, rgb(5, 66, 131) 0%, rgb(1, 95, 184) 40%, rgb(0, 101, 195) 100%)",
  },
};
